import axios, { AxiosInstance } from "axios";
import authTokenService from "common/authTokenService";
import { CancellationToken } from "common/ui/useCancellationToken";

type IAdminHttpClient = AxiosInstance;

export default class AdminHttpClient {

    static getProxyClient(merchantId?: string, cxt?: CancellationToken): IAdminHttpClient {
        return this.getClientInternal(merchantId, import.meta.env.REACT_APP_PROXY_API_BASE_URL, cxt);
    }

    private static getClientInternal(merchantId: string, baseUrl: string, cxt?: CancellationToken): IAdminHttpClient {
        const defaultHeaders = {
            Authorization: `Bearer ${authTokenService.getToken()}`,
            'x-merchant-id': merchantId
        };

        const client = axios.create({
            baseURL: baseUrl,
            headers: defaultHeaders,
            signal: cxt?.signal
        });

        const httpClient = new AdminHttpClient();
        return { ...client, ...httpClient } as IAdminHttpClient;
    }
}